module.exports = __webpack_public_path__ + "static/media/_MIC2348.image.3a7e4b40.png";